import React, { useState } from 'react';

const CompanyDropdown = () => {
  const [selectedCompany, setSelectedCompany] = useState(null);

  const companies = [
    {
      name: "Acadecraft",
      // logo: "https://www.acadecraft.com/favicon.gif",
    },
    {
      name: "Acadestudio",
      logo: "https://www.acadestudio.com/assets/images-new/favicon.svg",
    },
    {
      name: "Acadereality",
      // logo: "https://www.acadereality.com/images/favicon.webp",
    },
    {
      name: "NoLogo Organization",
      // logo: "", // Simulating missing logo
    },
  ];

  const handleSelect = (company) => {
    setSelectedCompany(company);
  };

  const getRandomColor = (name) => {
    const colors = [
      "#FF5733", "#33B5E5", "#AA66CC", "#99CC00", "#FFBB33",
      "#FF4444", "#00C851", "#4285F4", "#2BBBAD", "#aa00ff"
    ];
    let index = 0;

    for (let i = 0; i < name.length; i++) {
      index += name.charCodeAt(i);
    }

    return colors[index % colors.length];
  };

  return (
    <li className="nav-item d-none d-sm-inline-block">
      <div className="dropdown">
        <button
          type="button"
          className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
          id="navbarAppsDropdown"
          data-bs-toggle="dropdown"
          aria-expanded="false"
          data-bs-dropdown-animation=""
        >
          {selectedCompany ? (
            selectedCompany.logo ? (
              <img
                className="avatar avatar-xs avatar-4x3"
                src={selectedCompany.logo}
                alt={selectedCompany.name}
              />
            ) : (
              <div className="avatar avatar-xs avatar-soft-dark rounded-circle d-flex align-items-center justify-content-center">
                <span className="avatar-initials fw-semibold">
                  {selectedCompany.name.charAt(0).toUpperCase()}
                </span>
              </div>
            )
          ) : (
            <i className="bi-app-indicator" />
          )}
        </button>

        <div
          className="dropdown-menu dropdown-menu-end dropdown-card navbar-dropdown-menu navbar-dropdown-menu-borderless"
          aria-labelledby="navbarAppsDropdown"
          style={{ width: "15rem" }}
        >
          <div className="card-body card-body-height">
            {companies.map((company, index) => (
              <button style={{ padding: '0', marginBottom: '10px' }}
                key={index}
                type="button"
                className="dropdown-item text-start"
                onClick={() => handleSelect(company)}
              >
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0">
                    {company.logo ? (

                      <>
                        <div style={{
                          width: '30px',
                          height: '30px',
                          border: '1px solid #ddd',
                          borderRadius: '100%',
                          display: 'flex',
                          justifyContent: 'center',
                          alignItems: 'center'
                        }}>
                          <img
                            className="avatar avatar-xs avatar-4x3"
                            src={company.logo}
                            alt={company.name}
                            style={{ borderRadius: '100%', height: '25px', objectFit: 'contain' }}
                          />
                        </div>
                      </>
                    ) : (
                      <div className="avatar  avatar-soft-dark rounded-circle d-flex align-items-center justify-content-center" style={{
                        background: getRandomColor(company.name),
                        width: '27px',
                        height: '27px',
                        borderRadius: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        color: '#fff',
                        fontSize: '13px'
                      }}>
                        <span className="avatar-initials fw-semibold">
                          {company.name.charAt(0).toUpperCase()}
                        </span>
                      </div>
                    )}
                  </div>
                  <div className="flex-grow-1 text-truncate ms-3">
                    <p className="mb-0" style={{
                      color: '#000',
                      fontSize: '15px',
                      fontWeight: '500'
                    }}>{company.name}</p>
                  </div>
                </div>
              </button>
            ))}
          </div>
          <div style={{
            textAlign: 'center',
            borderTop: '1px solid #ddd',
            marginTop: '13px'
          }}>
            <button style={{
              color: '#007afb',
              textDecoration: 'none',
              fontSize: '14px',
              textAlign: 'center'
            }}
              type="button"
              className="card-footer text-center btn btn-link"
              onClick={() => {
                // Handle "Organizations menu" click here
                alert("Organizations menu clicked!");
              }}
            >
              Organizations menu <i className="bi-chevron-right" />
            </button>
          </div>

        </div>
      </div>
    </li>
  );
};

export default CompanyDropdown;
